<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Archyvarų ataskaitų sąrašas</h3>
    <naikinimas-archyvaras-search
      class="mt-1 mb-1"
      :loading="loading"
      @search="searchAktas"
      @cancel="cancelAktas"
    />

    <template v-if="showList">
      <v-data-table
        :loading="loading"
        :class="tableClass"
        :headers="headers"
        :items="itemsList"
        :hide-default-footer="hideFooter"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :sort-by.sync="pagination.sort"
        :sort-desc.sync="pagination.sortDesc"
        :server-items-length="pagination.total"
        :items-per-page="pagination.pageSize"
        :page.sync="pagination.page"
        @update:options="updatePagination"
        single-expand
        :expanded.sync="expanded"
        item-key="nak_id"
      >
        <template #top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <el-button
              :loading="loading"
              primary
              @click.native="aktasArchyvarui()"
            >
              Formuoti
            </el-button>
          </v-toolbar>
        </template>
        <template #[`item.bylos`]="{ item }">
          <el-byla
            v-for="byla in item.bylos"
            :key="byla.byl_id"
            :byla="byla"
            in-line
            color="primary"
          />
        </template>
        <template #[`item.nak_busena`]="{ item }">
          <div class="mt-1 mb-1">
            <el-aktas-busena :busena="item.nak_busena" />
            <template v-if="item.isVykdoma">
              <div>{{ item.sunaikinta }}/{{ item.naikintinas_kiekis }}</div>
            </template>
          </div>
        </template>
        <template #[`item.nak_sukurimo_data`]="{ item }">
          <div class="nowrap">{{ item.nak_sukurimo_data_split.diena }}</div>
          <div class="nowrap">{{ item.nak_sukurimo_data_split.laikas }}</div>
        </template>
        <template #[`item.nak_dvs_data`]="{ item }">
          <div class="nowrap">{{ item.nak_dvs_data_split.diena }}</div>
        </template>
        <template #[`item.parametrai`]="{ item }">
          <el-switch
            v-if="item.showParametrai"
            class="mt-0 mb-2"
            v-model="item.expandedParametrai"
            @click.native="changeExpandedParametrai(item)"
          />
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="nowrap">
            <el-button
              v-if="item.canFormuoti"
              class="my-0"
              x-small
              :key="`formuoti-${item.nak_id}`"
              :disabled="loading && !item.loading"
              :loading="item.loading"
              @click.native="aktasPerformuoti(item)"
              >Performuoti</el-button
            >
          </div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td></td>
          <td :colspan="headers.length - 1" class="ml-0 pl-0 pb-2">
            <naikinimas-archyvaras-parametrai
              :parametrai="item.padaliniai"
              :loading="loading"
            />
          </td>
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </template>

    <modal-aktas-archyvaras
      v-model="showAktasArchyvarui"
      :loading="loading"
      :padaliniai="padaliniai"
      @confirmAktasArchyvarui="confirmAktasArchyvarui"
    />
    <modal-delete
      title="Šalinti aktą archyvarui?"
      :text="
        `Ar norite pašalinti aktą archyvarui <strong>Nr. ${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import math from '../../mixins/math'
import NaikinimasArchyvarasSearch from './NaikinimasArchyvarasSearch'
import NaikinimasArchyvarasParametrai from './NaikinimasArchyvarasParametrai'
import ModalAktasArchyvaras from '../modals/ModalAktasArchyvaras'
import ModalDelete from '../modals/ModalDelete'

export default {
  name: 'NaikinimasArchyvaras',
  components: {
    NaikinimasArchyvarasSearch,
    NaikinimasArchyvarasParametrai,
    ModalAktasArchyvaras,
    ModalDelete,
  },
  mixins: [math],
  data() {
    return {
      pageloading: true,
      loading: false,
      searchData: {},
      aktai: [],
      padaliniai: {},
      itemsPerPageOptions: [3, 10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
      showList: false,
      showResult: false,
      resultMsg: null,
      expanded: [],
      showAktasArchyvarui: false,
      showDelete: false,
      modalDeleteVardas: null,
      modalDeleteItem: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Akto Nr.',
          align: 'center',
          value: 'nak_id',
          width: 80,
        },
        {
          text: 'Aktas',
          align: 'center',
          value: 'bylos',
        },
        {
          text: 'Suformavimo data',
          align: 'center',
          value: 'nak_sukurimo_data',
          width: 100,
        },
        {
          text: 'Objektas',
          align: 'left',
          value: 'objekto_tipas',
        },
        {
          text: 'Išregistravimo metai',
          align: 'left',
          value: 'nak_metai',
        },
        {
          text: 'Aktą suformavo',
          align: 'left',
          value: 'atnaujino',
        },
        {
          text: 'Akto būsena',
          align: 'center',
          value: 'nak_busena',
        },
        {
          text: 'Formavimo parametrai',
          align: 'center',
          value: 'parametrai',
          width: 80,
        },
        {
          text: 'Veiksmai',
          align: 'left',
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.aktai.map((item, index) => {
        item.nak_sukurimo_data_split = this.splitDate(item.nak_sukurimo_data)

        item.showParametrai = item.nak_objekto_tipas === 1

        item.bylos = item.bylos.map(byla => {
          byla.byl_tipas = `naikinimo_aktas`
          byla.byl_url = `byla/${byla.byl_id}/${byla.byl_hash}/content`
          return byla
        })

        if (item.bylos.length > 1) {
          item.bylos.push({
            byl_id: 0,
            byl_tipas: `naikinimo_zip`,
            byl_pavadinimas: 'aktai.zip',
            byl_url: `/naikinimo-aktas/${item.nak_id}/zip`,
          })
        }

        item.canFormuoti = item.nak_busena === 'nesuformuota'

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    tableClass() {
      return 'aktas-table'
    },
  },
  created() {
    this.getKlasif()
  },
  methods: {
    getKlasif() {
      const data = {
        klasifikatoriai: ['admin_aktas_padaliniai'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.padaliniai = res.data.list.admin_aktas_padaliniai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    searchAktas(searchData) {
      this.searchData = searchData
      this.showResult = false
      this.getData(true)
    },
    cancelAktas() {
      this.searchData = {}
      this.aktai = []
      this.showList = false
      this.showResult = false
    },
    getData(resetPageNr = false) {
      this.pageloading = true
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`naikinimo-aktas/sarasas-archyvarui`, data)
        .then(res => {
          this.aktai = res.data.naikinimo_aktai
          this.pagination = { ...this.pagination, ...res.data.pagination }
          if (
            this.pagination.page === 1 &&
            this.aktai.length > 0 &&
            this.aktai[0].nak_busena === 'laukia_patvirtinimo'
          ) {
            this.aktai[0].expandedParametrai = true
            this.expanded = [this.aktai[0]]
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.paginationloading = false
          this.showList = true
          this.showAktasArchyvarui = false
          this.showDelete = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.pageloading) {
        this.paginationloading = true
        this.getData()
      }
      this.pageloading = false
    },
    changeExpandedParametrai(item) {
      this.clearExpanded(item)
      if (item.expandedParametrai) {
        this.expanded = [item]
      } else {
        this.expanded = []
      }
    },
    clearExpanded(item) {
      this.aktai.forEach(e => {
        if (e.nak_id != item.nak_id) {
          e.expandedParametrai = false
        }
      })
    },
    aktasPerformuoti(item) {
      this.loading = true
      item.loading = true

      this.$axios
        .post(`naikinimo-aktas/${item.nak_id}/performuoti`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.aktai = []
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
          item.loading = false
        })
        .finally(() => {
          //item.loading = false
        })
    },
    aktasArchyvarui() {
      this.showAktasArchyvarui = true
    },
    confirmAktasArchyvarui(item) {
      this.loading = true
      const data = {
        ...item,
      }

      this.$axios
        .post(`naikinimo-aktas/archyvarui`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
        })
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.nak_id
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`naikinimo-aktas/${item.nak_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData(true)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.showDelete = false
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss">
.aktas-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px -4px 8px -5px rgba(50, 50, 50, 0.75);
}
</style>
